import { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import Cookies from 'universal-cookie';
import { setDealerData, resetDealerData } from '../../../core/reducers/dealer';
import { DEALER_DATA_COOKIE_NAME } from '../../../utils/constants';
var useDealerFromCookie = function () {
    var dispatch = useDispatch();
    var cookiesRef = useRef(new Cookies());
    useEffect(function () {
        var cookies = cookiesRef.current;
        if (!cookies)
            return;
        // on component mount, sync initial data to redux store
        var dealerInCookies = cookies.get(DEALER_DATA_COOKIE_NAME);
        dispatch(setDealerData(dealerInCookies));
        var onCookiesChange = function (_a) {
            var name = _a.name, value = _a.value;
            if (name === DEALER_DATA_COOKIE_NAME) {
                dispatch(setDealerData(value));
            }
        };
        // event listener for subsequent updates from cookies
        cookies.addChangeListener(onCookiesChange);
        return function () {
            cookies.removeChangeListener(onCookiesChange);
            dispatch(resetDealerData());
        };
    }, [dispatch]);
};
export default useDealerFromCookie;
